// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var Curry = require("rescript/lib/js/curry.js");
var UserCredential$SmartcutsMacros = require("./UserCredential.bs.js");
var CustomMapBuilders$SmartcutsMacros = require("./CustomMapBuilders.bs.js");

function t_encode(v) {
  return Curry._1(UserCredential$SmartcutsMacros.DbId.id_encode, v);
}

function t_decode(v) {
  return Curry._1(UserCredential$SmartcutsMacros.DbId.id_decode, v);
}

var cmp = Caml.caml_string_compare;

var MapCredentialDbId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode,
      t_decode: t_decode,
      cmp: cmp
    });

exports.MapCredentialDbId = MapCredentialDbId;
/* MapCredentialDbId Not a pure module */
